import { AsrFilterConfig } from 'src/api/types';
import { FormModel } from './index';
import { SecondaryTypeMap } from './const';

export const transform = (data: AsrFilterConfig[] = []): FormModel => {
    const defaultLang = data.find((item) => item.secondaryType === SecondaryTypeMap.LANG);

    const adaptionEnabled = data.find((item) => item.secondaryType === SecondaryTypeMap.LANG);

    const defaultSecondaryLang = data.find((item) => item.secondaryType === SecondaryTypeMap.LANG);

    const defaultASRModel = data.find((item) => item.secondaryType === SecondaryTypeMap.LANG);

    const enabled = data.find((item) => item.secondaryType === SecondaryTypeMap.ENABLED);

    const rules = data.filter((item) => item.secondaryType === SecondaryTypeMap.RULES);

    return {
        defaultLang,
        defaultSecondaryLang,
        defaultASRModel,
        enabled,
        rules,
        adaptionEnabled,
    };
};
